/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_InvestorInputs */

const cs_enum_investor = /** @type {(inputs: Enum_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

const en_enum_investor = /** @type {(inputs: Enum_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

/**
* | output |
* | --- |
* | "Investor" |
*
* @param {Enum_InvestorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_investor = /** @type {((inputs?: Enum_InvestorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_InvestorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_investor(inputs)
	return cs_enum_investor(inputs)
});